export * from './base';
/**
 * YesOrNo 布尔值枚举
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-06-10 15:50:14
 * @prop YES 1 是/允许
 * @prop NO 0 否/禁止/不允许
 */
export var BooleanType;
(function (BooleanType) {
    BooleanType[BooleanType["YES"] = 1] = "YES";
    BooleanType[BooleanType["NO"] = 0] = "NO";
})(BooleanType || (BooleanType = {}));
//# sourceMappingURL=advanced.js.map